import React from 'react';

interface ChartLoaderProps {
  height?: string | number;
  showLegend?: boolean;
  showTitle?: boolean;
  containerClassName?: string;
  chartClassName?: string;
  legendClassName?: string;
}

const ChartLoader: React.FC<ChartLoaderProps> = ({
  height = 350,
  showLegend = false,
  showTitle = false,
  containerClassName = "",
  chartClassName = "",
  legendClassName = ""
}) => {
  const heightClass = typeof height === 'number' ? `h-[${height}px]` : `h-[${height}]`;

  return (
    <div className={`animate-pulse ${containerClassName}`}>
      {/* Title skeleton */}
      {showTitle && (
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
      )}
      
      {/* Chart area skeleton */}
      <div className={`${heightClass} bg-gray-200 rounded-lg mb-4 ${chartClassName}`}></div>
      
      {/* Legend skeleton */}
      {showLegend && (
        <div className={`flex justify-center gap-6 ${legendClassName}`}>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-gray-200 rounded-full"></div>
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-gray-200 rounded-full"></div>
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChartLoader;